import React, { useState } from 'react';
import { FiUsers, FiPlayCircle, FiSliders, FiClock, FiSend, FiCalendar } from 'react-icons/fi';
import EmployeesTab from './EmployeesTab';
import RunPayrollTab from './RunPayrollTab';
import RatesTab from './RatesTab';
import TimesheetsTab from './TimesheetsTab';
import RemittancesTab from './RemittancesTab';
import YearEndTab from './YearEndTab';
import { confirmDiscardChanges } from '../../lib/unsavedChanges';
import './PayrollPage.css';

type TabId = 'employees' | 'timesheets' | 'run' | 'remittances' | 'yearend' | 'rates';
const TABS: { id: TabId; label: string; icon: React.ReactNode }[] = [
  { id: 'employees', label: 'Employees', icon: <FiUsers /> },
  { id: 'timesheets', label: 'Timesheets', icon: <FiClock /> },
  { id: 'run', label: 'Run Payroll', icon: <FiPlayCircle /> },
  { id: 'remittances', label: 'Remittances', icon: <FiSend /> },
  { id: 'yearend', label: 'Year-End (T4/ROE)', icon: <FiCalendar /> },
  { id: 'rates', label: 'Statutory Rates', icon: <FiSliders /> },
];

export default function PayrollPage() {
  const [tab, setTab] = useState<TabId>('employees');
  // Bumped on every tab click → keyed <Fragment> remounts the tab to its landing
  // state (guard-then-land rule: re-clicking the current tab resets it, never a no-op).
  const [resetKey, setResetKey] = useState(0);

  const switchTab = async (id: TabId) => {
    // Guard unsaved work first (opens the app modal when a form is dirty).
    if (!(await confirmDiscardChanges())) return;
    setTab(id);
    setResetKey((k) => k + 1);
  };

  return (
    <div className="pay-page">
      <div className="pay-head">
        <div>
          <h1><FiPlayCircle /> Payroll</h1>
          <p className="pay-sub">Canadian payroll — CRA source deductions (CPP/EI + federal &amp; provincial tax), pay runs, stubs &amp; GL posting.</p>
        </div>
      </div>

      <div className="pay-tabs" role="tablist">
        {TABS.map((t) => (
          <button
            key={t.id}
            role="tab"
            aria-selected={tab === t.id}
            className={`pay-tab ${tab === t.id ? 'active' : ''}`}
            onClick={() => switchTab(t.id)}
          >
            {t.icon} {t.label}
          </button>
        ))}
      </div>

      <React.Fragment key={`${tab}-${resetKey}`}>
        {tab === 'employees' && <EmployeesTab />}
        {tab === 'timesheets' && <TimesheetsTab />}
        {tab === 'run' && <RunPayrollTab />}
        {tab === 'remittances' && <RemittancesTab />}
        {tab === 'yearend' && <YearEndTab />}
        {tab === 'rates' && <RatesTab />}
      </React.Fragment>
    </div>
  );
}
